const analyticsTrackEvent = Object.freeze({
  CO_BROWSE_AGENT_JOIN: 'Session Start - Agent Join',
  CO_BROWSE_SESSION_END: 'Session End',
  CO_BROWSE_SESSION_REQUEST: 'Session Request - Agent Request'
})

export { analyticsTrackEvent }
